import React, { useRef } from 'react'
import classNames from 'classnames'

const UNAVAILABLE = 'Unavailable'
const AVAILABLE = 'Available'
const BLOCKED = 'Blocked'

// Currently the Card only display Available and set
// the status to unavailable for everything else
function Card({
  title,
  status,
  statuses,
  styles,
  isNewRegistry,
  selectDomain,
  filters,
  imageUrl,
  checkoutUrl,
  noStatus,
  isRegistrar,
  contactLink,
  tierLabel,
  isJumpstarter,
  selectedDomain,
}) {
  let state
  if (isNewRegistry) {
    if (statuses.includes('REGISTERED')) {
      state = UNAVAILABLE
    } else if (statuses.includes('BLOCKED') || statuses.includes('BLOCKED_OVERRIDE')) {
      state = BLOCKED
    } else {
      state = AVAILABLE
    }
  } else {
    state = status !== AVAILABLE ? UNAVAILABLE : status
  }
  const headlineClass = classNames('headline', {
    red: state === UNAVAILABLE || state === BLOCKED,
  })

  const cardClass = classNames('card', {
    'card--registrar': isRegistrar,
  })

  const linkRef = useRef(null)

  const handleCardClick = (e) => {
    if (isJumpstarter) {
      // Only send event if target is the link, otherwise pass click through to the link (which will trigger this again)
      if (e.target.nodeName === 'A') {
        // Send explicit GTM event
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'registrar_select',
          domain: selectedDomain,
          registrar: title,
        })
      } else {
        linkRef.current.click()
      }
    } else {
      return
    }
  }

  return (
    <div className={cardClass} style={styles} onClick={handleCardClick}>
      {tierLabel && <div className='card__tier-label'>{tierLabel}</div>}
      <div className='card__inner'>
        {imageUrl && <img src={imageUrl} alt={title} className='card__image' />}
        {title && <h5 className='card__title'>{title}</h5>}
        {!noStatus && state && <p className={headlineClass}>{state}</p>}
        {filters && (
          <ul className='card__description'>
            {filters.map((filter, index) => {
              return <li key={index} dangerouslySetInnerHTML={{ __html: filter }}></li>
            })}
          </ul>
        )}
        {selectDomain && state === AVAILABLE && (
          <button
            onClick={() => {
              selectDomain(title)
            }}
            className='card__button button c-btn'
          >
            Select
          </button>
        )}
        {contactLink && state === BLOCKED && (
          <a
            href={contactLink}
            className='card__button button c-btn'
            data-gtm-referral={title}
            aria-label={`Contact us about blocked domain ` + title}
            ref={linkRef}
          >
            Contact us
          </a>
        )}
        {checkoutUrl && (
          <a
            href={checkoutUrl}
            target='_blank'
            className='card__button button c-btn'
            data-gtm-referral={title}
            aria-label={`Select ` + title}
            ref={linkRef}
          >
            Select
          </a>
        )}
      </div>
    </div>
  )
}

export default Card
